import { render, staticRenderFns } from "./ListTodoStatistics.vue?vue&type=template&id=09af0b69&scoped=true&"
import script from "./ListTodoStatistics.vue?vue&type=script&lang=js&"
export * from "./ListTodoStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ListTodoStatistics.vue?vue&type=style&index=0&id=09af0b69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09af0b69",
  null
  
)

/* custom blocks */
import block0 from "./ListTodoStatistics.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports